import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "18",
  "aria-hidden": "true",
  viewBox: "0 0 14 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.25 6.768c0-2.803-2.352-5.076-5.25-5.076S1.75 3.965 1.75 6.768c0 .437.164 1.113.558 2.016.383.874.926 1.84 1.55 2.816 1.037 1.628 2.24 3.2 3.142 4.32.904-1.12 2.107-2.693 3.143-4.321.623-.976 1.166-1.942 1.55-2.816.393-.903.557-1.58.557-2.016m1.75 0c0 3.08-4.266 8.565-6.136 10.828a1.125 1.125 0 0 1-1.728 0C4.266 15.333 0 9.848 0 6.768 0 3.03 3.135 0 7 0s7 3.031 7 6.768m-5.833 0c0-.623-.523-1.128-1.167-1.128s-1.167.505-1.167 1.128S6.356 7.895 7 7.895s1.167-.505 1.167-1.127m-4.084 0c0-1.558 1.306-2.82 2.917-2.82s2.917 1.262 2.917 2.82S8.61 9.588 7 9.588s-2.917-1.263-2.917-2.82" }, null, -1)
  ])))
}
export default { render: render }